<template>
  <b-modal size="xl" scrollable v-model="show" centered :title="!isDebitor ? 'Adresse wählen' : 'Debitor wählen'">
    <b-row>
      <b-col md="4">
        <b-form-input type="search" v-model="search" placeholder="Suchen" debounce="200" style="margin-bottom: 6px"></b-form-input>
      </b-col>
      <b-col><b-button variant="primary" class="" @click="$emit('add-address'); show = false">{{!isDebitor ? 'Neue Adresse' : 'Neuen Debitor'}}</b-button></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table id="my-table" :items="remainingAddress"
                 striped hover selectable
                 :fields="fields"
                 :sort-by="sortBy"
                 :sort-desc="sortDesc"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelected">
          <template #table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                style="min-width: 100px"
            >
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" :disabled="!canContinue" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "AddressDialog",

  props:{
    isAGeber: Boolean,
    isDebitor: Boolean,
    addresses: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      search: '',
      sortBy: 'name_1',
      sortDesc: false,
      show: false,
      newAddress: {},
      selected: [],

    }
  },
  computed: {
    fields() {
      return [
        {key: "debitor", label: this.isAGeber ? 'Debitor' : "PK-Nummer", sortable: true},
        {key: "salutation", label: 'Anrede', sortable: true},
        {key: "name_1", label: 'Name 1', sortable: true},
        {key: "first_name", label: 'Name 2', sortable: true},
        {key: "country", label: 'Land', sortable: true},
        {key: "street", label: 'Strasse', sortable: true},
        {key: "street_number", label: 'Hausnr.', sortable: true},
        {key: "zip_code", label: 'PLZ', sortable: true},
        {key: "city", label: 'Ort', sortable: true},
        //{key: "phone_number", label: 'Telefon', sortable: true},
        //{key: "fax", label: 'Fax', sortable: true},
        {key: "email", label: 'Email', sortable: true},
      ];
    },
    canContinue() {
      return this.selected.length > 0;
    },
    remainingAddress: function () {
      let res = [];
      const filterText = this.search.trim().toLowerCase();
      if (filterText === "") {
        for (let i = 0; i < this.addresses.length; i++) {
          if (this.addresses[i].debitor.length > 0 || !this.isDebitor) {
            res.push(this.addresses[i]);
          }
        }
        return res;
      }
      for (let i = 0; i < this.addresses.length; i++) {
        if ((this.addresses[i].debitor.length > 0 || !this.isDebitor) && (
            this.addresses[i].name.toLowerCase().indexOf(filterText) > -1
            || this.addresses[i].debitor.toLowerCase().indexOf(filterText) > -1
            || this.addresses[i].name_1.toLowerCase().indexOf(filterText) > -1
            || this.addresses[i].first_name.toLowerCase().indexOf(filterText) > -1
            || this.addresses[i].name_2.toLowerCase().indexOf(filterText) > -1
            || this.addresses[i].street.toLowerCase().indexOf(filterText) > -1
            || this.addresses[i].city.toLowerCase().indexOf(filterText) > -1
            || this.addresses[i].email.toLowerCase().indexOf(filterText) > -1)
        ) {
          res.push(this.addresses[i]);
        }
      }
      return res;
    }
  },
  methods: {
    rowSelected(items) {
      if (items.length === 0) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },
    onSave() {
      this.show = false;
      this.$emit("set-address", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.selected = [];
      this.newAddress = {};
      this.search = '';
      this.show = true;
    },
    getReturnData: function () {
      return this.selected[0];
    },
  }
}
</script>

<style scoped>
.b-select-item {
  height: 1.75rem;
  width: 1.75rem;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  color: #696969;
  text-align: center;
  line-height: 1.5rem;
  vertical-align: middle;
  margin-top: 1px;
}
.b-heading {
  line-height: 1.45;
  margin-bottom: 0;
  padding-left: 12px
}
.b-description {
  padding-left: 4.375rem;
}
</style>
